import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

// containers
import Loading from 'components/atoms/Loading'
import ErrorMessage from 'components/shared/ErrorMessage'

// shared components (registration only)
import RegistrationStep from 'components/register/shared/RegistrationStep'

// shared components (registration and account)
import FlexibilityText from 'components/shared/Cart/FlexibilityText'

// Financial aid components
import FinancialAidBanner from 'components/account/Plans/FinancialAidBanner'
import FinancialAidInfo from 'components/account/Plans/FinancialAidInfo'
import FinancialAidApplicationModal from 'components/account/Plans/FinancialAidApplicationModal'

// Local components
import Form from './Form'

const Cart = props => {
  const {
    loading, // via withQuery
    account, // via withQuery
    session, // via withQuery
    sessions, // via withQuery
    refetchCart // via withQuery
  } = props

  return (
    <RegistrationStep>
      <Box mt={2}>
        <ErrorMessage />
      </Box>
      {!account || loading ? (
        <Loading />
      ) : (
        <>
          <FinancialAidBanner account={account} session={session} />
          <Container>
            <Typography paragraph>
              Please select one or more plans for each camper.
            </Typography>
            <FlexibilityText />
          </Container>

          <Form {...props} session={session} />
          <FinancialAidApplicationModal sessions={sessions} refetchCart={refetchCart} />
        </>
      )}
    </RegistrationStep>
  )
}

export default Cart
